import {
  useQueries,
  keepPreviousData,
  UseQueryResult,
} from "@tanstack/react-query";
import {
  CashFlowAndPerformanceStatisticsList,
  performanceByDepots,
} from "@rentablo/api/apiv1";
import { ACCOUNT_PERFORMANCE_BY_ACCOUNT_IDS } from "@api/cacheKeys";
import {
  groupByAccountAndCurrency,
  QueriesByAccount,
  QuerySpec,
} from "./querySpecs";

export const usePerformanceStatisticQueries = (
  specs: QuerySpec[],
  range: { startDate: Date; endDate: Date },
  accessToken: string | undefined
): QueriesByAccount<CashFlowAndPerformanceStatisticsList> => {
  const { startDate, endDate } = range;

  const results = useQueries({
    queries: specs.map((spec) => ({
      queryKey: [
        ACCOUNT_PERFORMANCE_BY_ACCOUNT_IDS,
        [spec.accountId],
        startDate.getTime(),
        endDate.getTime(),
        "day",
        spec.displayCurrency,
      ],
      queryFn: (): Promise<CashFlowAndPerformanceStatisticsList> =>
        performanceByDepots(accessToken, {
          createCashFlowAndPerformanceStatisticsParams: {
            accountIds: [spec.accountId],
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            interval: "day",
            displayCurrency: spec.displayCurrency,
            cashFlowAndPerformanceStatisticsParamsList: [
              { assetClasses: [], includeCash: false, includeDividends: true },
            ],
          },
        }),
      enabled: !!accessToken,
      staleTime: Infinity,
      placeholderData: keepPreviousData,
    })),
  });

  return groupByAccountAndCurrency(
    specs,
    results as UseQueryResult<CashFlowAndPerformanceStatisticsList, unknown>[]
  );
};
